'use client'

/**
 * https://docs.fontawesome.com/web/use-with/react/use-with#getting-font-awesome-css-to-work
 * NB: This config must be set in a client component, and before any FontAwesome components are loaded.
 * https://github.com/FortAwesome/react-fontawesome/issues/568#issuecomment-2450889273
 */
import {config} from '@fortawesome/fontawesome-svg-core'
// Add fontawesome icon css as part of our own css bundles / prevent initial oversized icons
import '@fortawesome/fontawesome-svg-core/styles.css'

config.autoAddCss = false

export function FontAwesomeConfig() {
  return null
}
